import React from "react";
import { TabsContent } from "../../misc/Tabs";
import { TutorialsList } from "./TutorialsList";
import { tutorialsData } from "./tutorials-data";

interface TutorialsProps {
    innerTab?: string;
}

const Tutorials: React.FC<TutorialsProps> = ({ innerTab }) => {
    const mainTutorials = tutorialsData.slice(0, 2);

    return (
        <TabsContent value="tutorials">
            {/* <TutorialsComingSoon /> */}
            <div className="container mx-auto px-4 py-12">
                <h1 className="text-4xl font-bold mb-2 text-center text-primary">
                    Tutorials
                </h1>
                <p className="text-xl text-gray-600 mb-12 text-center">
                    Learn how to make the most of our app with these helpful
                    guides
                </p>
                <TutorialsList initialTutorials={mainTutorials} />
            </div>
        </TabsContent>
    );
};

export default Tutorials;
